import { snapshot } from 'valtio'
import type React from 'react'
import { proxyRefund } from '../refundProxy'
import { buildAxiosInstance } from '../../../../../../../shared/utils/apiUtils'
import { convertToCentValue } from '../../../../../../../shared/utils/formattingUtils'
import { GtagEvents, gtmTrackButtonPress } from '../../../../../../../shared/utils/gtmUtils'

export async function executeRefundCreate (e: React.FormEvent<HTMLFormElement>): Promise<void> {
  e.preventDefault()
  gtmTrackButtonPress(GtagEvents.REFUND_SUBMIT)

  proxyRefund.apiCallRefundCreate.loading = true
  proxyRefund.apiCallRefundCreate.error = null
  const { formValues, transaction } = snapshot(proxyRefund)

  const emailSendVal = formValues.email || null

  try {
    const response = await buildAxiosInstance().post(
      '/api/refunds/create',
      {
        amountCents: convertToCentValue(Number(formValues.refundAmount), 'USD'),
        email: emailSendVal,
        shouldSendReceipt: true,
        transactionId: String(transaction?.id)
      }
    )
    if (response.data.error) {
      proxyRefund.apiCallRefundCreate.error = response.data.error
    } else {
      proxyRefund.completed = true
    }
  } catch (e) {
    if (e instanceof Error) {
      proxyRefund.apiCallRefundCreate.error = e.message
    }
  } finally {
    proxyRefund.apiCallRefundCreate.loading = false
  }
}
